<template>
  <ConditionalTextarea
    v-model="rejection"
    :radio-label="$tt('ever_refused_entry')"
    :radio-hint="$tt('visa_rejection_or_expel')"
    :textarea-label="$tt('describe_rejection')"
    :textarea-hint="$tt('which_country_date')"
  />
</template>

<script setup lang="ts">
const rejection = defineModel<string>({ required: true });
</script>